// extracted by mini-css-extract-plugin
export default {"categoryBox":"CategoryList_categoryBox__qT555","categoryList":"CategoryList_categoryList__OkN8m","active":"CategoryList_active__0U2eX"};